import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./user.svg?react";

export const UserIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
